/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_3_Item_Monitoring_DescInputs */

const en_privacy_section_3_item_monitoring_desc = /** @type {(inputs: Privacy_Section_3_Item_Monitoring_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sentry helps us detect and fix technical issues to ensure a smooth experience`)
};

const lv_privacy_section_3_item_monitoring_desc = /** @type {(inputs: Privacy_Section_3_Item_Monitoring_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sentry palīdz mums atklāt un novērst tehniskas problēmas, lai vietne darbotos nevainojami`)
};

/**
* | output |
* | --- |
* | "Sentry helps us detect and fix technical issues to ensure a smooth experience" |
*
* @param {Privacy_Section_3_Item_Monitoring_DescInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_3_item_monitoring_desc = /** @type {((inputs?: Privacy_Section_3_Item_Monitoring_DescInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_3_Item_Monitoring_DescInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_3_item_monitoring_desc(inputs)
	return en_privacy_section_3_item_monitoring_desc(inputs)
});